<div class="radar-chart" #chartTemplate></div>